const __WEBPACK_NAMESPACE_OBJECT__ = flarum.reg.get('ramon-chat', 'forum/state/chat');